import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";
import API_BASE_URL from "../../API/ConfigAPI";
import Modal from "../../components/Modal/Modal";
import BarreNavigation from "../../components/BarreNavigation/BarreNavigation";
import Navbarhorizontal from "../../components/Navbarhorizontal/Navbarhorizontal";
import CompanyForm from "../../components/CompanyForm/CompanyForm";
import "../../ToastifyCustom.css";
import "./companylist.css";

function CompanyList() {
  const [societesSansGestionnaire, setSocietesSansGestionnaire] = useState([]);
  const [filteredCompanies, setFilteredCompanies] = useState([]);
  const [showTarifModal, setShowTarifModal] = useState(false);
  const [selectedTarif, setSelectedTarif] = useState("");
  const [tarifValue, setTarifValue] = useState("");
  const [selectedCompanyIds, setSelectedCompanyIds] = useState([]);

  const [confirmDeleteModal, setConfirmDeleteModal] = useState({
    isOpen: false,
    companyId: null,
  });

  const [showConfirmFacturationModal, setShowConfirmFacturationModal] =
    useState(false);
  const [siretToGenerate, setSiretToGenerate] = useState(null);

  const [selectedBadge, setSelectedBadge] = useState("all");

  const tarifOptions = [
    { value: "montant_ftc", label: "Montant FTC" },
    { value: "tarif_unitaire_bulletin_unitaire", label: "Bulletin" },
    { value: "tarif_teulade", label: "Teulade" },
    { value: "tarif_acces_silae", label: "Accès SILAE" },
    { value: "tarif_RC", label: "Rupture Conventionnelle" },
    { value: "tarif_licenciement", label: "Licenciement" },
    { value: "tarif_contrat", label: "Contrat" },
    { value: "tarif_maladie", label: "Maladie" },
    { value: "tarif_avenant", label: "Avenant" },
    { value: "tarif_mission_excep", label: "Mission exceptionnelle" },
    { value: "tarif_stc", label: "Solde tout compte" },
  ];

  // ✅ Fonction de validation de modification en masse
  const handleMassUpdate = async () => {
    if (!selectedTarif || !tarifValue || selectedCompanyIds.length === 0) {
      toast.error(
        "Veuillez sélectionner un tarif, une valeur et au moins une société."
      );
      return;
    }

    const token = localStorage.getItem("token");

    try {
      await Promise.all(
        selectedCompanyIds.map(async (id) => {
          const company = companies.find((c) => c.id === parseInt(id));
          if (!company) return;

          const updatedCompany = {
            ...company,
            [selectedTarif]: parseFloat(tarifValue.replace(",", ".")),
          };

          const response = await fetch(
            `${API_BASE_URL}/home/api/societes/${id}/`,
            {
              method: "PUT",
              headers: {
                Authorization: `Token ${token}`,
                "Content-Type": "application/json",
              },
              body: JSON.stringify(updatedCompany),
            }
          );

          if (!response.ok) {
            const errorData = await response.json();
            const error = new Error(
              "Erreur lors de la mise à jour des tarifs."
            );
            error.response = { data: errorData };
            throw error;
          }
        })
      );

      toast.success("Tarif mis à jour pour les sociétés sélectionnées !");
      setSelectedCompanyIds([]);
      setSelectedTarif("");
      setTarifValue("");
      setShowTarifModal(false);
      fetchCompanies();
    } catch (err) {
      console.error(err);
      toast.error("Erreur lors de la mise à jour des tarifs.");
    }
  };

  const [companies, setCompanies] = useState([]);
  const [users, setUsers] = useState([]);
  // Ajoutez l'état pour gérer l'affichage du modal
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [newCompany, setNewCompany] = useState({
    siret: "",
    nom: "",
    adresse: "",
    ville: "",
    code_postal: "",
    email: "",
    // gestionnaire_nom: "",
    societe_gestionnaire: "E2P",
    compte: "",
    compte_de_base: "412",
    montant_ftc: 0,
    // tarif_subvention: 0,
    tarif_unitaire_bulletin_unitaire: 0,
    tarif_teulade: 0,

    tarif_RC: 0,
    tarif_licenciement: 0,
    tarif_contrat: 0,
    tarif_maladie: 0,
    tarif_avenant: 0,
    tarif_mission_excep: 0,
    tarif_stc: 0,
    gestionnaire: null,
    societe_a_facturer: "Oui", // Default value for the toggle switch
  });
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [editingCompany, setEditingCompany] = useState(null);
  const [formError, setFormError] = useState("");
  const [modalTitle, setModalTitle] = useState("");
  const [searchTerm, setSearchTerm] = useState(""); // Nouvel état pour la recherche
  const [searchTermModal, setSearchTermModal] = useState("");

  const [isFacturationModalOpen, setIsFacturationModalOpen] = useState(false);
  const [selectedMonth, setSelectedMonth] = useState("");

  const fetchCompanies = async () => {
    const token = localStorage.getItem("token");
    try {
      const response = await fetch(`${API_BASE_URL}/home/api/societes/`, {
        headers: {
          Authorization: `Token ${token}`,
        },
      });

      if (!response.ok)
        throw new Error("Erreur lors de la récupération des sociétés");

      const data = await response.json();
      setCompanies(data);
      setFilteredCompanies(data);
    } catch (error) {
      console.error("Erreur lors de la récupération des sociétés:", error);
    }
  };

  useEffect(() => {
    const token = localStorage.getItem("token");

    const fetchData = async () => {
      try {
        // 1️⃣ Récupération des sociétés
        const societesResponse = await fetch(
          `${API_BASE_URL}/home/api/societes/`,
          {
            headers: {
              Authorization: `Token ${token}`,
            },
          }
        );

        if (!societesResponse.ok) {
          throw new Error("Erreur lors de la récupération des sociétés");
        }

        const societesData = await societesResponse.json();
        setCompanies(societesData);
        setFilteredCompanies(societesData);
        setSocietesSansGestionnaire(
          societesData.filter((s) => !s.gestionnaire)
        );

        // 2️⃣ Récupération des utilisateurs (gestionnaires)
        const usersResponse = await fetch(`${API_BASE_URL}/home/api/users/`, {
          headers: {
            Authorization: `Token ${token}`,
          },
        });

        if (!usersResponse.ok) {
          throw new Error("Erreur lors de la récupération des utilisateurs");
        }

        const usersData = await usersResponse.json();
        setUsers(usersData);

        // 3️⃣ Appliquer le scroll conditionnel une seule fois après récupération des données
        const table = document.querySelector("table");
        const rowCount = table?.getElementsByTagName("tr").length || 0;
        const seuil = 14;

        if (rowCount > seuil) {
          table.style.maxHeight = "500px";
          table.style.overflowY = "auto";
        }
      } catch (error) {
        console.error("Erreur lors du chargement des données:", error);
      }
    };

    fetchData();
  }, []);

  const showAllCompanies = () => {
    setFilteredCompanies(companies);
    setSelectedBadge("all");
  };

  const showCompaniesWithoutGestionnaire = () => {
    setFilteredCompanies(companies.filter((c) => !c.gestionnaire));
    setSelectedBadge("sans_gestionnaire");
  };

  const showInactiveCompanies = () => {
    setFilteredCompanies(
      companies.filter((c) => c.societe_a_facturer === "Non")
    );
    setSelectedBadge("inactives");
  };

  const handleDelete = (companyId) => {
    setConfirmDeleteModal({
      isOpen: true,
      companyId: companyId,
    });
  };

  const confirmDeleteCompany = async () => {
    const token = localStorage.getItem("token");
    try {
      const response = await fetch(
        `${API_BASE_URL}/home/api/societes/${confirmDeleteModal.companyId}/`,
        {
          method: "DELETE",
          headers: {
            Authorization: `Token ${token}`,
          },
        }
      );

      if (!response.ok)
        throw new Error("Erreur lors de la suppression de la société");

      toast.success("Société supprimée avec succès !", {
        className: "myToastClassNamesuccés",
        progressClassName: "myToastProgressClassName",
      });
      setCompanies((prev) =>
        prev.filter((company) => company.id !== confirmDeleteModal.companyId)
      );
      setFilteredCompanies((prev) =>
        prev.filter((company) => company.id !== confirmDeleteModal.companyId)
      );
      setConfirmDeleteModal({ isOpen: false, companyId: null });
      fetchCompanies();
    } catch (error) {
      console.error("Erreur lors de la suppression de la société:", error);
      toast.error("Erreur lors de la suppression de la société.", {
        className: "myToastClassNameerreur",
        progressClassName: "myToastProgressClassName",
      });
      setConfirmDeleteModal({ isOpen: false, companyId: null });
    }
  };

  const cancelDelete = () => {
    setConfirmDeleteModal({ isOpen: false, companyId: null });
  };

  const handleEditClick = (company) => {
    setEditingCompany(company); // Stocke la société à modifier
    setNewCompany({
      siret: company.siret,
      nom: company.nom,
      adresse: company.adresse,
      ville: company.ville,
      code_postal: company.code_postal,
      email: company.email,
      gestionnaire_nom: company.gestionnaire_nom,
      societe_gestionnaire: company.societe_gestionnaire,
      compte: company.compte,
      compte_de_base: company.compte_de_base,
      montant_ftc: company.montant_ftc,
      // tarif_subvention: company.tarif_subvention,
      tarif_unitaire_bulletin_unitaire:
        company.tarif_unitaire_bulletin_unitaire,
      tarif_teulade: company.tarif_teulade,
      tarif_acces_silae: company.tarif_acces_silae,
      tarif_RC: company.tarif_RC,
      tarif_licenciement: company.tarif_licenciement,
      tarif_contrat: company.tarif_contrat,
      tarif_maladie: company.tarif_maladie,
      tarif_avenant: company.tarif_avenant,
      tarif_mission_excep: company.tarif_mission_excep,
      tarif_stc: company.tarif_stc,
      entite_facturation: company.entite_facturation,
      gestionnaire: company.gestionnaire,
      societe_a_facturer: company.societe_a_facturer || "Oui",
    }); // Pré-remplit le formulaire
    setIsEditModalOpen(true); // Ouvre le modal de modification
    setModalTitle("METTRE À JOUR LES INFORMATIONS");
  };
  // Fonction pour gérer l'ajout d'une nouvelle société pour les champs non tarifaires
  const handleInputChange = (e) => {
    const { name, value } = e.target;

    if (name === "gestionnaire_nom") {
      const selectedUser = users.find((user) => user.id.toString() === value);
      setNewCompany({
        ...newCompany,
        gestionnaire: selectedUser ? selectedUser.id : null,
      });
    } else {
      setNewCompany({ ...newCompany, [name]: value });
    }
  };

  const handleTarifInputChange = (e) => {
    const { name, value } = e.target;

    // Autorise explicitement la chaîne vide pour permettre d'effacer le champ
    if (value === "") {
      setNewCompany({ ...newCompany, [name]: "" });
      return; // Arrête la fonction ici pour ne pas aller plus loin dans la validation
    }

    // Continue avec la validation pour les nombres avec virgules
    // eslint-disable-next-line
    const regex = /^\d+(\,\d{0,2})?$/; // Accepte les nombres avec jusqu'à deux chiffres après la virgule

    if (regex.test(value) || value === "") {
      // Remplace les virgules par des points pour la conversion en nombre
      setNewCompany({ ...newCompany, [name]: value.replace(",", ".") });
    } else {
      // Si la valeur n'est pas valide, vous pourriez vouloir remettre la valeur précédente ou afficher un message d'erreur
      // Mais pour ce cas, ne fait rien de plus ici pour ne pas réintroduire une valeur invalide.
    }
  };

  const handleToggleChange = () => {
    setNewCompany({
      ...newCompany,
      societe_a_facturer:
        newCompany.societe_a_facturer === "Oui" ? "Non" : "Oui",
    });
  };
  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const [lastCreatedSiret, setLastCreatedSiret] = useState(null); // Nouvel état pour stocker le dernier SIRET créé

  const handleSubmit = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem("token");
    const method = editingCompany ? "PUT" : "POST";
    const url = editingCompany
      ? `${API_BASE_URL}/home/api/societes/${editingCompany.id}/`
      : `${API_BASE_URL}/home/api/societes/`;

    try {
      const response = await fetch(url, {
        method: method,
        headers: {
          Authorization: `Token ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(newCompany),
      });

      const data = await response.json();

      if (!response.ok) {
        const error = new Error("Erreur lors de la soumission du formulaire.");
        error.response = { data };
        throw error;
      }

      const successMessage = editingCompany
        ? "Société modifiée avec succès !"
        : "Société ajoutée avec succès !";

      toast.success(successMessage, {
        className: "myToastClassNamesuccés",
        progressClassName: "myToastProgressClassName",
      });

      if (!editingCompany) {
        setCompanies([...companies, data]);
        setLastCreatedSiret(data.siret);
        confirmFacturation(data.siret);
      } else {
        setCompanies(
          companies.map((company) =>
            company.id === editingCompany.id ? data : company
          )
        );
      }

      setIsModalOpen(false);
      setIsEditModalOpen(false);
      resetNewCompanyForm();
      fetchCompanies();
    } catch (error) {
      handleError(error);
    }
  };

  const confirmFacturation = (siret) => {
    setSiretToGenerate(siret);
    setShowConfirmFacturationModal(true);
  };

  const getPreviousMonths = () => {
    const today = new Date();
    const monthNames = [
      "janvier",
      "février",
      "mars",
      "avril",
      "mai",
      "juin",
      "juillet",
      "août",
      "septembre",
      "octobre",
      "novembre",
      "décembre",
    ];
    const currentMonth = `${
      monthNames[today.getMonth()]
    }-${today.getFullYear()}`;
    const lastMonth =
      today.getMonth() === 0
        ? `${monthNames[11]}-${today.getFullYear() - 1}`
        : `${monthNames[today.getMonth() - 1]}-${today.getFullYear()}`;
    return [currentMonth, lastMonth];
  };

  const handleMonthSelection = (siret) => {
    const selectedMonth = document.getElementById("month-selection").value;
    if (selectedMonth) {
      generateFacturation(siret, selectedMonth);
      setIsFacturationModalOpen(false); // Close the modal after selection
    }
  };

  const askForFacturation = (siret) => {
    setSelectedMonth(getPreviousMonths()[0]); // Set default to current month
    setIsFacturationModalOpen(true);
  };
  const generateFacturation = async (siret, moisFacturation) => {
    const token = localStorage.getItem("token");
    const url = `${API_BASE_URL}/home/api/generate-facturations/${siret}/${moisFacturation}/`;

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          Authorization: `Token ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ siret, moisFacturation }),
      });

      if (!response.ok) {
        throw new Error("Erreur lors de la génération de la Facturation");
      }

      toast.success("Facturation générée avec succès !");
    } catch (error) {
      console.error(error);
      toast.error("Erreur lors de la génération de la Facturation");
    }
  };

  const resetNewCompanyForm = () => {
    setNewCompany({
      nom: "",
      adresse: "",
      ville: "",
      code_postal: "",
      email: "",
      societe_gestionnaire: "E2P",
      compte: "",
      compte_de_base: "412",
      montant_ftc: 0,
      tarif_unitaire_bulletin_unitaire: 0,
      tarif_teulade: 0,
      tarif_acces_silae: 0,
      tarif_RC: 0,
      tarif_licenciement: 0,
      tarif_contrat: 0,
      tarif_maladie: 0,
      tarif_avenant: 0,
      tarif_mission_excep: 0,
      tarif_stc: 0,
      entite_facturation: "",
      gestionnaire: null,
      societe_a_facturer: "Oui", // Reset to default value
    });
    setEditingCompany(null);
    setFormError("");
  };

  const handleError = (error) => {
    console.error("Erreur lors de la soumission du formulaire:", error);

    if (error.response && error.response.data) {
      const data = error.response.data;

      if (typeof data === "string") {
        // Cas d'une réponse directement textuelle
        toast.error(data, {
          className: "myToastClassNameerreur",
          progressClassName: "myToastProgressClassName",
        });
      } else if (typeof data === "object") {
        // Cas d'une réponse de type objet JSON (exemple : { error: "..." })
        const errorMessage =
          data.error ||
          Object.values(data).flat().join(", ") ||
          "Erreur inconnue.";
        toast.error(errorMessage, {
          className: "myToastClassNameerreur",
          progressClassName: "myToastProgressClassName",
        });
      }
    } else {
      toast.error("Une erreur s'est produite lors de l'envoi du formulaire.", {
        className: "myToastClassNameerreur",
        progressClassName: "myToastProgressClassName",
      });
    }
  };

  const openAddModal = () => {
    setIsModalOpen(true);
    setModalTitle("CRÉER UNE NOUVELLE SOCIÉTÉ");
    // Réinitialiser le formulaire et les erreurs lors de l'ouverture du modal d'ajout
    setNewCompany({
      nom: "",
      adresse: "",
      ville: "",
      code_postal: "",
      email: "",
      // gestionnaire_nom: "",
      societe_gestionnaire: "E2P",
      compte: "",
      compte_de_base: "412",
      montant_ftc: 0,
      tarif_acces_silae: 0,
      tarif_unitaire_bulletin_unitaire: 0,
      tarif_teulade: 0,

      tarif_RC: 0,
      tarif_licenciement: 0,
      tarif_contrat: 0,
      tarif_maladie: 0,
      tarif_avenant: 0,
      tarif_mission_excep: 0,
      tarif_stc: 0,
      entite_facturation: "",
      gestionnaire: null,
      societe_a_facturer: "Oui",
    });
    setFormError("");
    setEditingCompany(null);
    fetchCompanies();
  };

  // Ajoutez cette fonction pour gérer la fermeture des modals
  const closeModal = () => {
    setIsModalOpen(false);
    setIsEditModalOpen(false);
    setNewCompany({
      nom: "",
      adresse: "",
      ville: "",
      code_postal: "",
      email: "",
      // gestionnaire_nom: "",
      gestionnaire: null,
      societe_gestionnaire: "E2P",
      compte: "",
      compte_de_base: "412",
      montant_ftc: 0,

      tarif_unitaire_bulletin_unitaire: 0,
      tarif_acces_silae: 0,
      tarif_RC: 0,
      tarif_licenciement: 0,
      tarif_contrat: 0,
      tarif_maladie: 0,
      tarif_avenant: 0,
      tarif_mission_excep: 0,
      tarif_stc: null,
      entite_facturation: "",
      societe_a_facturer: "Oui",
    });
    setFormError("");
    setEditingCompany(null);
  };

  return (
    <div className="parent-layout">
      <BarreNavigation />
      <div className="content">
        <div>
          <Navbarhorizontal />
        </div>
        <div className="container">
          <h1>Gestion du portefeuille</h1>

          <Modal
            isOpen={confirmDeleteModal.isOpen}
            onClose={cancelDelete}
            title="Confirmer la suppression"
          >
            <div className="modal-body">
              <p>Êtes-vous sûr de vouloir supprimer cette société ?</p>
              <div
           className="suprime-list-modal"
              >
                <button
                  className="submit-button"
                  onClick={confirmDeleteCompany}
                >
                  Supprimer
                </button>
                <button className="cancel-button" onClick={cancelDelete}>
                  Annuler
                </button>
              </div>
            </div>
          </Modal>

          {showConfirmFacturationModal && (
            <Modal
              isOpen={true}
              title="Confirmer la génération de facturation"
              onClose={() => setShowConfirmFacturationModal(false)}
            >
              <div className="modal-body">
                <p>
                  Voulez-vous générer la facturation pour cette nouvelle société
                  ?
                </p>
                <div
                className="modal-confirm-générer "
                >
                  <button
                    className="submit-button"
                    onClick={() => {
                      askForFacturation(siretToGenerate);
                      setShowConfirmFacturationModal(false);
                    }}
                  >
                    Oui, générer
                  </button>
                  <button
                    className="cancel-button"
                    onClick={() => setShowConfirmFacturationModal(false)}
                  >
                    Non, annuler
                  </button>
                </div>
              </div>
            </Modal>
          )}

          <Modal
            isOpen={isFacturationModalOpen}
            onClose={() => setIsFacturationModalOpen(false)}
            title="Sélectionnez le mois pour la facturation"
          >
            <div className="select-month">
              <select
                id="month-selection"
                value={selectedMonth}
                onChange={(e) => setSelectedMonth(e.target.value)}
              >
                {getPreviousMonths().map((month, index) => (
                  <option key={index} value={month}>
                    {month}
                  </option>
                ))}
              </select>
            </div>
            <div className="btn-modal">
              <button
                className="submit"
                onClick={() => handleMonthSelection(lastCreatedSiret)}
              >
                Confirmer
              </button>
              <button
                className="cancel"
                onClick={() => {
                  setIsFacturationModalOpen(false); // Ferme la modal
                  toast.info("La génération de la facturation a été annulée.", {
                    className: "myToastClassNameinfo",
                    progressClassName: "myToastProgressClassName",
                  });
                }}
              >
                Annuler la génération
              </button>
            </div>
          </Modal>
          <div className="entete-portefeuille">
            <div className="search-container">
              <input
                type="text"
                placeholder="Recherche"
                value={searchTerm}
                onChange={handleSearchChange}
                className="search-input"
              />
            </div>
            <div
              className="badges-container"
             
            >
              <span
                className="badge badge-total"
                style={{
                  opacity: selectedBadge === "all" ? 1 : 0.5,
                }}
                onClick={showAllCompanies}
              >
                Total sociétés ({companies.length})
              </span>
              <span
                className="badge badge-sans-gestionnaire"
                style={{
                  opacity: selectedBadge === "sans_gestionnaire" ? 1 : 0.5,
                }}
                onClick={showCompaniesWithoutGestionnaire}
              >
                Sans gestionnaire ({societesSansGestionnaire.length})
              </span>
              <span
                className="badge badge-inactives"
                style={{
                 
                  opacity: selectedBadge === "inactives" ? 1 : 0.5,
                }}
                onClick={showInactiveCompanies}
              >
                Sociétés inactives (
                {companies.filter((c) => c.societe_a_facturer === "Non").length}
                )
              </span>
            </div>
            <div className="continer-btn-companylist">
              <div className="btn-container-portefeuille">
                <button
                  className="btn-ajout-portefeuille"
                  onClick={openAddModal}
                >
                  <span className="icon-plus">+</span>
                  Nouvelle société
                </button>
              </div>
              <div className="btn-container-portefeuille">
                <button
                  onClick={() => setShowTarifModal(true)}
                  className="btn-ajout-portefeuille"
                >
                  Modification groupée
                </button>
              </div>
            </div>
          </div>

          {showTarifModal && (
            <Modal
              isOpen={true}
              title="Mise à jour groupée des tarifs"
              onClose={() => setShowTarifModal(false)}
            >
              <div className="modal-body">
                <div className="input-group">
                  <label>Tarif à modifier</label>
                  <select
                    value={selectedTarif}
                    onChange={(e) => setSelectedTarif(e.target.value)}
                    style={{
                      color: selectedTarif === "" ? "#999" : "#000", // <-- ici je change la couleur en fonction
                    }}
                  >
                    <option value="" disabled>
                      -- Choisir un tarif --
                    </option>
                    {tarifOptions.map((option) => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="input-group">
                  <label>Nouvelle valeur</label>
                  <input
                    type="text"
                    value={tarifValue}
                    onChange={(e) => setTarifValue(e.target.value)}
                    placeholder="Ex: 25,50"
                  />
                </div>

                <div className="input-group">
                  <label>Sociétés à modifier</label>
                  <div style={{ marginBottom: "0.5rem" }}>
                    <input
                      type="text"
                      placeholder="Rechercher par nom ou SIRET"
                      value={searchTermModal}
                      onChange={(e) => setSearchTermModal(e.target.value)}
                      style={{ width: "100%", padding: "6px" }}
                    />
                  </div>
                  <div className="champ-list-societe"
                 
                  >
                    {companies
                      .filter(
                        (c) =>
                          c.nom
                            .toLowerCase()
                            .includes(searchTermModal.toLowerCase()) ||
                          c.siret.includes(searchTermModal)
                      )
                      .map((c) => (
                        <label
            
                          key={c.id}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                            padding: "4px 0",
                            cursor: "pointer",
                            width: "100%",
                            whiteSpace: "nowrap",
                          }}
                        >
                          <input
                            type="checkbox"
                            checked={selectedCompanyIds.includes(
                              c.id.toString()
                            )}
                            onChange={(e) => {
                              if (e.target.checked) {
                                setSelectedCompanyIds((prev) => [
                                  ...prev,
                                  c.id.toString(),
                                ]);
                              } else {
                                setSelectedCompanyIds((prev) =>
                                  prev.filter((id) => id !== c.id.toString())
                                );
                              }
                            }}
                            style={{
                              width: "18px",
                              height: "18px",
                            }}
                          />

                          <span title={c.nom}>
                            {c.nom.length > 25
                              ? `${c.nom.slice(0, 25)}...`
                              : c.nom}{" "}
                            ({c.siret})
                          </span>
                        </label>
                      ))}
                  </div>
                </div>

                <div className="form-actions">
                  <button
                    className="cancel-button"
                    onClick={() => {
                      setShowTarifModal(false);
                      setSelectedTarif("");
                      setTarifValue("");
                      setSelectedCompanyIds([]);
                      setSearchTermModal("");
                    }}
                  >
                    Fermer
                  </button>
                  <button className="submit-button" onClick={handleMassUpdate}>
                    Sauvegarder
                  </button>
                </div>
              </div>
            </Modal>
          )}

          <div className="table-container">
            <table className="companylist_table">
              <thead>
                <tr>
                  <th>Siret</th>
                  <th>Nom</th>
                  <th>Adresse</th>
                  <th>Ville</th>
                  <th>Code postal</th>
                  <th>Email</th>
                  <th>Gestionnaire</th>

                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {filteredCompanies
                  .filter((company) => {
                    // Si aucun terme de recherche n'est entré, afficher toutes les sociétés
                    if (!searchTerm) {
                      return true;
                    }
                    // Sinon, afficher seulement les sociétés dont le nom contient le terme de recherche
                    return (
                      company.nom
                        .toLowerCase()
                        .includes(searchTerm.toLowerCase()) ||
                      company.siret.includes(searchTerm)
                    );
                  })
                  .map((company) => (
                    <tr key={company.id}>
                      <td>{company.siret}</td>
                      <td>{company.nom}</td>
                      <td>{company.adresse}</td>
                      <td>{company.ville || "N/A"}</td>
                      <td>{company.code_postal || "N/A"}</td>
                      <td>{company.email || "N/A"}</td>
                      <td>{company.gestionnaire_nom || "N/A"}</td>

                      <td>
                        <div className="btn-container">
                          <button
                            className="edit-btn"
                            onClick={() => handleEditClick(company)}
                          >
                            <FontAwesomeIcon icon={faEdit} />
                          </button>

                          <button
                            className="delete-btn"
                            onClick={() => handleDelete(company.id)}
                          >
                            <FontAwesomeIcon icon={faTrash} />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>

          <Modal
            isOpen={isModalOpen || isEditModalOpen}
            onClose={closeModal}
            title={modalTitle}
          >
            <div className="modal-body">
              <CompanyForm
                newCompany={newCompany}
                users={users}
                handleInputChange={handleInputChange}
                handleTarifInputChange={handleTarifInputChange}
                handleSubmit={handleSubmit}
                closeModal={closeModal}
                handleToggleChange={handleToggleChange}
                formError={formError}
              />
            </div>
          </Modal>
        </div>
      </div>
    </div>
  );
}

export default CompanyList;
